<template>
  <div class="auth-wrapper auth-basic px-2">
  <div class="auth-inner my-2">
    <!-- two steps verification basic-->
    <div class="card mb-0">
      <div class="card-body">
        <a href="javascript:void(0);" class="brand-logo">
          <img src="https://test-creditfixrr-spaces.nyc3.digitaloceanspaces.com/Marketing/creditfixrr-best-credit-repair-software-logo.png" alt="creditfixrr logo">
        </a>

        <h2 class="card-title fw-bolder mb-1">Two Step Verification 💬</h2>
        <p class="card-text mb-75">
          Hey {{name}},
          We Sent a Verification Code to Your Email Address. Enter the code to verify your account.
        </p>
        <!-- <p class="card-text fw-bolder mb-2">******{{phone}}</p> -->

        <form class="mt-2" v-on:submit.prevent="verifyOtp">
          <h6>Type your 6 digit security code</h6>
          <div class="auth-input-wrapper d-flex align-items-center justify-content-between">
            <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
              maxlength="1" autofocus="" v-model="input_1"/>

            <input class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
              maxlength="1" type="text"  v-model="input_2"/>

            <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
              maxlength="1"  v-model="input_3"/>

            <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
              maxlength="1"  v-model="input_4"/>

            <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
              maxlength="1"  v-model="input_5"/>

            <input type="text" class="form-control auth-input height-50 text-center numeral-mask mx-25 mb-1"
              maxlength="1"  v-model="input_6"/>
          </div>
          <div>
            <p class="text-danger" v-if="error != ''" >{{error}}</p>
          </div>
          <button type="submit" class="btn btn-primary w-100" tabindex="4">Verify Account</button>
        </form>

        <p class="text-justify  mt-2">
          <span>Didn’t get the code?</span>
          <a href="#" v-on:click ="resendCode($event,2,'email')">
            <span>&nbsp;
              Resend code
              <span v-if="type == 'email'">
                <span v-if="time_left == '0:00'"></span>
                <span v-else>in {{time_left}}</span>
              </span>
              <span v-else>
              </span>
            </span>
          </a>
        </p>
        <p class="text-justify font-weight-bold "><b>Having Problems?</b></p>
        <p class="text-justify ">
          <a href="#" v-on:click ="resendCode($event,1,'sms')">
            <span>&nbsp;
              Send verification code to ******{{phone}}
              <span v-if="type == 'sms'">
                <span v-if="time_left == '0:00'"></span>
                <span v-else>in {{time_left}}</span>
              </span>
              <span v-else>
              </span>
            </span>
          </a>
        </p>
        <!-- <p class="text-center mt-2">
           <span>Time left : {{time_left}}</span>
        </p> -->
      </div>
    </div>
    <!-- /two steps verification basic -->
  </div>
</div>
</template>

<script>
  import {ref} from 'vue'
  // import axios from 'axios'
  export default{
    name:'OtpVerifyComponent',
    components: {
    },
    data(){
      return{
        input_1:"",
        input_2:"",
        input_3:"",
        input_4:"",
        input_5:"",
        input_6:"",
        otpcode:'',
        opt_length:process.env.OTP_LENGTH,
        phone:'',
        name:'',
        error:'',
        resend_res:false,
        time_left:'0:00',
        minutes:0,
        seconds:0,
        request_code:"",
        type:null
      }
    },
    created(){

    },
    mounted(){
      this.phone = this.$attrs['phone'];
      this.name = this.$attrs['name'];
      this.authentication();
    },
    methods:{
      verifyOtp(e){
        e.preventDefault();
        let h = this;
        this.otpcode = `${h.input_1}${h.input_2}${h.input_3}${h.input_4}${h.input_5}${h.input_6}`;
        var otpcode = this.otpcode,route='',verified=false;
        var token = {
          'token':otpcode
        }
        if(this.checkIfNotEmpty(otpcode)){
          axios.post('/otp/verify',token).then(({data})=>{
            verified=data.data.verified;
            if(verified){
              route=data.data.route;
              window.location = route
            }
            this.error =data.data.message
          }).catch((e)=>{

          })
        }else{
          //  Two Steps Verification
          const numeralMask = document.querySelectorAll('.numeral-mask');
          if (numeralMask.length) {
            numeralMask.forEach(e => {
              if(h.checkIfNotEmpty(e.value)){
                e.classList.add('isValid')
                this.error = ''
              }else{
                e.classList.add('isInvalid')
                this.error = 'All fields must be filled'
              }
            });
          }
        }

      },
      authentication(){
        var inputContainer = document.querySelector('.auth-input-wrapper');
        // Get focus on next element after max-length reach
        inputContainer.onkeyup = function (e) {
          var target = e.srcElement;
          var maxLength = parseInt(target.attributes['maxlength'].value, 10);
          var currentLength = target.value.length;

          if (e.keyCode === 8) {
            if (currentLength === 0) {
              var next = target;
              while ((next = next.previousElementSibling)) {
                if (next == null) break;
                if (next.tagName.toLowerCase() == 'input') {
                  next.focus();
                  break;
                }
              }
            }
          } else {
            if (currentLength >= maxLength) {
              var next = target;
              while ((next = next.nextElementSibling)) {
                if (next == null) break;
                if (next.tagName.toLowerCase() == 'input') {
                  next.focus();
                  break;
                }
              }
            }
          }
        };
      },
      checkIfNotEmpty(val){
        this.error = ''
        if((val !=="" || val !==null ) && typeof Number(val) && val.length == 6){
          return true;
        }else{
          return false;
        }
      },
      showTimer(){
            var $this = this;
            $this.time_left = '2:00';

           let request_code = setInterval( function() {
                let timer = $this.time_left.split(':');
                var minutes = timer[0];
                var seconds = timer[1];
                seconds -=1;

                if (minutes < 0) return;
                else if (seconds < 0 && minutes != 0) {
                    minutes -= 1;
                    seconds = 59;
                }
                else if (seconds < 10 && length.seconds != 2) seconds = '0' + seconds;
                $this.time_left = minutes + ':' + seconds;
                if ($this.time_left == '0:00' ) {
                    clearInterval(request_code)
                };
            }, 1000);
      },
      resendCode(e,val,type){
        e.preventDefault();
        this.type = type;
        let status = {
          'status':0,
          'auth_type':val
        }
        if(this.time_left !== '0:00'){
          return toastr.error('Please wait for the timer to finish its count.','Two Step Verification');
        }
        axios.post('/otp/resend',status).then(({data})=>{
            this.showTimer();
            return toastr.success(`${data.data}`,'Two Step Verification');
        }).catch((e)=>{
            if(e.response.status == 429){
              return toastr.error(`${e.response.statusText}, please try agian after 2 minute.`,'Two Step Verification');
            }
            return toastr.error(`${e.response.statusText}`,'Two Step Verification');
        })
      }

    }
  }
</script>
<style>
  .isValid{
    border-color: #4b9a5e !important;
  }
  .isInvalid{
    border-color: #dc3545 !important;
  }

</style>
